import { buildQueryString, fetchJsonWithAuthorizationAndPersonation } from '../utils/fetch.utils';
import { CUSTOMER_SERVICE_URL } from '@/app-constants/env.constant';
import { objectToEntity } from '@/utils/transform.utils';
import { TenantList, TenantListSchema, TenantType } from '@/entities/tenant.entity';

const ROOT_URL = `${CUSTOMER_SERVICE_URL}/api`;

/**
 * Fetches related tenants' data based on the specified tenant type.
 *
 * @param tenantId - The tenant ID.
 * @param {TenantType} [tenantType] - Optional tenant type filter (e.g., 'partner', 'parent', 'child').
 * @param depth - Optional recursion depth.
 * @param signal - Optional signal to cancel the request.
 * @param includeSoldProducts - Optional flag to include sold products.
 * @returns {Promise<TenantList>} A promise that resolves to a list of tenants.
 */
export const getTenantsDropdownData = async (
  tenantId: string,
  tenantType?: TenantType,
  depth?: number,
  signal?: AbortSignal,
  includeSoldProducts?: boolean,
): Promise<TenantList> => {
  const queryString = buildQueryString({
    tenant_type: tenantType,
    tenant_id: tenantId,
    ...(!!depth && { level: depth }),
    ...(!!includeSoldProducts && { include_sold_products: true }),
  });

  const url = `${ROOT_URL}/tenants/related?${queryString}`;
  const apiResponse = await fetchJsonWithAuthorizationAndPersonation(url, { signal });
  return objectToEntity<TenantList>(TenantListSchema, apiResponse);
};
